import {ajaxProjectUpdate, ajaxRequest} from "./Ajax";
import Helper from "./Helper";
import Api from "./Api";

export async function popupEditWork(rowData) {
    const selInputDate = '#sw-input-date';
    const selInputVol = '#sw-input-qty';
    const selInputWorkers = '#sw-input-workers';
    const selInputCommentID = '#sw-input-comment-id';
    const selInputCommentText = '#sw-input-comment-text';

    const commentResponse = await Api.loadComment(rowData.id);

    rowData.comment = commentResponse?.success ? commentResponse.data : [];

    const createFormBody = (props) => {

        let popupHtml = $('<div class="esr-popup-fields flex flex-col gap-2"></div>');

        const elFieldDate = ESR.View.label({
            text: ESR.lang.date,
            attrs: {class: 'form-control form-control-date w-full'}
        });

        const elInputDate = ESR.View.input({
            id: 'sw-input-date',
            class: 'input input-bordered'
        });

        const elFieldQty = ESR.View.label({
            text: ESR.lang.qty,
            altText: props.unit,
            attrs: {class: 'form-control form-control-vol w-full'}
        });


        const elInputQty = ESR.View.input({
            type: 'number',
            value: props?.qty ?? '',
            id: 'sw-input-qty',
            class: 'input input-bordered'
        });

        const elFieldComment = ESR.View.label({
            text: 'Comentariu',
            attrs: {class: 'form-control form-control-vol w-full'}
        });

        const elInputCommentID = ESR.View.input({
            type: 'hidden',
            value: props?.comment.id ?? '',
            id: 'sw-input-comment-id',
            class: 'input input-bordered'
        });

        const elInputCommentText = ESR.View.textarea({
            value: props?.comment.comment ?? '',
            id: 'sw-input-comment-text',
            class: 'textarea input-bordered',
            rows: 3
        });

        const elFieldWorkers = ESR.View.label({
            text: ESR.lang.workers,
            attrs: {class: 'form-control form-control-workers w-full'}
        });

        const inputWorkersValue = props.workers.map(item => item.id);
        let inputWorkersOptions = [...ESR.workers];

        // Loop through props.workers and add to inputWorkersOptions if not already included
        props.workers.forEach(function (item) {
            // Check if inputWorkersOptions does not contain an item with the same id
            if (!inputWorkersOptions.some(option => option.value === item.id)) {
                inputWorkersOptions.push({
                    value: item.id,
                    label: item.name ?? 'User ' + item.id
                });
            }
        });

        const elInputWorkers = ESR.View.select({
            value: inputWorkersValue,
            id: 'sw-input-workers',
            name: 'workers',
            multiple: 1,
            options: inputWorkersOptions
        })

        elFieldDate.append(elInputDate);
        elFieldQty.append(elInputQty);
        elFieldWorkers.append(elInputWorkers);
        elFieldComment.append(elInputCommentID);
        elFieldComment.append(elInputCommentText);

        const row = $('<div class="grid grid-cols-2 gap-4"></div>')
        row.append(elFieldDate)
        row.append(elFieldQty)


        popupHtml.append(`<div class="mb-4 w-full text-left">${props.id} - ${props.service_title}</div>`)
        popupHtml.append(row)
        popupHtml.append(elFieldWorkers)
        popupHtml.append(elFieldComment)

        return popupHtml;
    }

    return ESR.Popup.fire({
        title: 'Editează',
        html: createFormBody(rowData),
        showCloseButton: true,
        confirmButtonText: ESR.lang.update,
        showLoaderOnConfirm: true,
        didOpen: () => {

            const dateValue = ESR.Helper.formatDate(rowData.date)

            $(selInputDate).attr('value', dateValue).datepicker({
                language: 'ro',
                todayBtn: true,
                autoclose: true,
                endDate: new Date(),
                format: 'yyyy mm dd'
            })

            // Initialize select2 with dropdownParent set to the Swal modal container
            $(selInputWorkers).select2({
                dropdownParent: $('.swal2-container') // Ensures dropdown is within the SweetAlert modal
            });
        },
        preConfirm: async () => {
            const elInputDate = $(selInputDate);
            const elInputVol = $(selInputVol);
            const elInputWorkers = $(selInputWorkers);
            const elInputCommentID = $(selInputCommentID);
            const elInputCommentText = $(selInputCommentText);

            let date = elInputDate.val();
            let volume = elInputVol.val();
            let commentText = elInputCommentText.val();
            let worker_ids = elInputWorkers.val();

            // Validate inputs
            const isValidDate = ESR.Helper.validateDate(date);
            const isValidVolume = Number.isInteger(parseInt(volume)) && parseInt(volume) > 0;

            // Check if the selected workers are valid (at least one selected)
            const areWorkersSelected = worker_ids && worker_ids.length > 0;

            if (!isValidDate) {
                Swal.showValidationMessage('Data nu este validă, formatul acceptat ' + ESR.Helper.formatDate(new Date()));
                return false;
            }

            if (!isValidVolume) {
                Swal.showValidationMessage('Volumul trebuie să fie un număr întreg pozitiv.');
                return false;
            }

            if (!areWorkersSelected) {
                Swal.showValidationMessage('Selectați cel puțin un angajat.');
                return false;
            }

            // Fetch old values for comparison
            const dateOld = rowData.date;
            const volumeOld = rowData.qty;
            const workersOld = rowData.workers.map(item => item.id);

            const isUpdateDate = date !== dateOld.replace(/-/g, ' ');
            const isUpdateVol = volume !== volumeOld
            const isUpdateWorkers = worker_ids.join(',') !== workersOld.join(',')
            const isUpdatedComment = rowData.comment?.comment !== commentText;

            if (!isUpdateDate && !isUpdateVol && !isUpdateWorkers && !isUpdatedComment) {
                Swal.showValidationMessage('Nu sunt actualizări de efectuat.');
                return false;
            }

            if (!isUpdateDate) date = '';
            if (!isUpdateVol) volume = '';
            if (!isUpdateWorkers) worker_ids = '';

            await ajaxRequest({
                action: "esr_update_work",
                data: {
                    id: rowData.id,
                    qty: volume,
                    date, worker_ids,
                    comment: {
                        id: elInputCommentID.val(),
                        text: commentText
                    },
                    modified_by: ESR.user.id
                }
            });
        },
        allowOutsideClick: () => !Swal.isLoading()
    })
}

export function popupEditUser(rowData) {

    const user_id = rowData.id;

    const defaultValues = {
        display_name: rowData?.name,
        email: rowData?.email,
        phone: rowData?.phone,
        coef: rowData?.coef,
        role: rowData?.role?.value
    }

    const htmlPopupBody = (props = {}) => {

        const elFieldCoeff = ESR.View.field(
            'sw-input-coef',
            {text: ESR.lang.coefficient},
            {type: 'number', value: props?.coef ?? '', name: 'coef', class: 'input input-bordered'}
        );

        // Prepare roles for the dropdown
        const rolesArray = Object.entries(ESR.user_roles).map(([value, label]) => ({value, label}));

        const elFieldRole = ESR.View.field(
            'sw-input-role',
            {text: 'Rol și Acces', attrs: {class: 'form-control'}},
            {
                type: 'select',
                value: props?.role?.value ?? 'subscriber',
                placeholder: '',
                options: rolesArray,
                class: 'w-full',
            }
        );

        // Create name and email input fields within their respective labels
        const elFieldName = ESR.View.field(
            'sw-input-name',
            {
                text: ESR.lang.user_name,
                class: 'form-control'
            },
            {
                type: 'text',
                value: props.name ?? '',
                class: 'input input-bordered'
            },
            {class: 'form-control col-span-2'}
        );


        const elFieldEmail = ESR.View.field(
            'sw-input-email',
            {
                text: ESR.lang.email,
                class: 'form-control'
            },
            {
                type: 'email',
                value: props.email ?? '',
                class: 'input input-bordered'
            },
            {class: 'form-control col-span-2'}
        );

        const elFieldPhone = ESR.View.field(
            'sw-input-phone',
            {
                text: 'Telefon',
                class: 'form-control'
            },
            {
                type: 'text',
                value: props.phone ?? '',
                class: 'input input-bordered'
            },
            {class: 'form-control col-span-2'}
        );

        // Assemble the popup HTML structure
        const popupHtml = $('<div class="esr-popup-fields grid grid-cols-2 gap-4"></div>');
        popupHtml.append(elFieldName, elFieldEmail, elFieldPhone, elFieldCoeff, elFieldRole);

        return popupHtml;
    }

    return ESR.Popup.fire({
        title: `Editare ` + rowData?.name,
        html: htmlPopupBody(rowData),
        showCloseButton: true,
        confirmButtonText: ESR.lang.save,
        showLoaderOnConfirm: true,
        willOpen: () => {
            Swal.getConfirmButton().disabled = true;

            // Add event listeners to input fields to enable the button on changes
            const inputs = Swal.getHtmlContainer().querySelectorAll('input, select');

            inputs.forEach(input => {
                input.addEventListener('input', () => {
                    // Enable the confirm button if any input has changed
                    Swal.getConfirmButton().disabled = false;
                });
            });
        },
        preConfirm: async () => {
            const popupFields = $('.esr-popup-fields')
            const inputName = popupFields.find('#sw-input-name')
            const inputEmail = popupFields.find('#sw-input-email')
            const inputPhone = popupFields.find('#sw-input-phone')
            const inputCoef = popupFields.find('#sw-input-coef')
            const inputRole = popupFields.find('#sw-input-role')

            let newData = {user_id}
            const email = inputEmail.val();

            // Function to compare and add changed values
            function addIfChanged(key, newValue) {
                if (newValue !== defaultValues[key]) newData[key] = newValue;
            }

            // Compare each field and add to newData if changed
            addIfChanged('display_name', inputName.val());
            addIfChanged('email', email);
            addIfChanged('phone', inputPhone.val());
            addIfChanged('coef', inputCoef.val());
            addIfChanged('role', inputRole.val());

            if (!ESR.Helper.validateEmail(email)) {
                Swal.showValidationMessage("Adresa de email nu este validă");
                return;
            }

            await ajaxRequest({action: "esr_update_user", data: newData});
        },
        allowOutsideClick: () => !Swal.isLoading()
    })

}

// Function to handle common Swal popup logic (add/edit)
export function popupCreateUpdateProject(rowData = {}, confirmBtnText) {
    const canEditOther = ESR.Helper.userCan('edit_others_project');
    const isEditMode = rowData?.id ? true : false;
    let bodyHTML;
    let popupTitle = '';
    const rowManagerID = rowData?.manager?.id ?? 0;
    const rowTitle = rowData?.post_title ?? '';
    const rowStatus = rowData?.status || 'publish';

    if (isEditMode) {
        // Check if a Manager tries to edit a project of another
        if (!canEditOther && parseInt(rowManagerID) !== parseInt(ESR.user.id)) {
            ESR.Popup.warning({
                html: `Mănagerul obiectivului este <b>${rowData.manager.name}</b>, Dvs. nu aveți permisiuni de editare.`,
                confirmButtonText: ESR.lang.close,
            });
            return;
        }
        popupTitle = 'Editează Obiectiv';
    } else {
        popupTitle = 'Adaugă Obiectiv';
    }

    const fieldTitle = ESR.View.field(
        'sw-input-title',
        {text: 'Denumire Obiectiv'},
        {'type': 'text', 'value': rowTitle}
    );

    let fieldManager = null;

    if (canEditOther) {
        fieldManager = ESR.View.field(
            'sw-input-manager',
            {text: 'Mănager'},
            {
                type: 'select',
                value: rowManagerID,
                placeholder: 'Selectează mănagerul',
                options: ESR?.managers
            }
        );
    } else {
        fieldManager = ESR.View.field(
            'sw-input-manager',
            {},
            {
                type: 'hidden',
                value: isEditMode ? rowManagerID : ESR.user.id
            }
        );
    }

    const fieldPostStatus = ESR.View.field(
        'sw-input-status',
        {text: ESR.lang.status},
        {
            type: 'select',
            value: rowStatus,
            options: [
                {value: 'publish', label: ESR.lang.status_publish},
                {value: 'finished', label: ESR.lang.status_finished}
            ]
        }
    );

    const popupContent = $(`<div class="esr-popup-fields grid grid-cols-1 gap-4"></div>`);
    popupContent.append(fieldTitle)
    if (canEditOther) popupContent.append(fieldManager)
    popupContent.append(fieldPostStatus)

    ESR.Popup.fire({
        title: popupTitle,
        html: popupContent,
        showCloseButton: true,
        confirmButtonText: confirmBtnText,
        showLoaderOnConfirm: true,
        didOpen: () => {
            // $('#sw-input-manager').select2({
            //     dropdownParent: $('.swal2-container') // Ensures dropdown is within the SweetAlert modal
            // });
        },
        preConfirm: async () => {
            const elInputTitle = $('#sw-input-title');
            const elSelectManager = $('#sw-input-manager');
            const elSelectStatus = $('#sw-input-status');
            const title = elInputTitle.val().trim();
            const status = elSelectStatus?.val() ?? 'publish';
            const manager_id = canEditOther ? elSelectManager.val() : ESR.user.id;
            const post_id = rowData?.id;

            // Validate title input
            if (!title.length) {
                Swal.showValidationMessage('Completează denumire obiectiv');
                elInputTitle.focus();
                return;
            }

            // Validate manager selection
            if (!manager_id) {
                Swal.showValidationMessage(ESR.lang.completeProjectManager);
                if (canEditOther) elSelectManager.focus();
                return;
            }

            return await ajaxProjectUpdate({title, manager_id, post_id, status});
        },
        allowOutsideClick: () => !Swal.isLoading()
    });
}

export function popupCreateUpdateService(rowData = {}, confirmBtnText) {

    let popupTitle = 'Adaugă Serviciu';
    const id = rowData?.ID ?? 0;
    let service_title = '';
    let category_id = '';
    let price_a = '';
    let price_c = '';
    let unit = '';
    let visibility = 1;

    if (id) {
        popupTitle = 'Editează Serviciu'
        service_title = rowData?.title
        category_id = rowData?.term_id
        price_a = rowData?.price_a
        price_c = rowData?.price_c
        unit = rowData?.unit
        visibility = rowData.visibility
    }

    const optionsCategorii = Object.entries(ESR.services_terms).map(item => ({
        value: item[0],
        label: item[1].term_name
    }));

    const optionsUnits = ESR.options.units.map(item => ({value: item, label: item}))

    const fieldTitle = ESR.View.field(
        'sw-input-title',
        {text: 'Denumire Serviciu'},
        {'type': 'text', 'value': service_title},
        {class: 'form-control col-span-2'}
    );

    const fieldCategory = ESR.View.field(
        'sw-input-category',
        {text: 'Categorie'},
        {
            type: 'select',
            value: category_id,
            class: 'w-full',
            placeholder: 'Selectează categoria',
            options: optionsCategorii
        },
        {class: 'form-control col-span-2'}
    );

    const fFieldUnit = ESR.View.field(
        'sw-input-unit',
        {text: 'Unitate'},
        {
            type: 'select',
            value: unit,
            options: optionsUnits
        }
    );

    const fFieldVisibility = ESR.View.field(
        'sw-input-visibility',
        {
            text: ESR.lang.visibility
        },
        {
            type: 'select',
            value: visibility,
            options: [
                {value: 'publish', label: ESR.lang.visible},
                {value: 'private', label: ESR.lang.hidden}
            ]
        }
    );

    const fieldPriceA = ESR.View.field(
        'sw-input-price-a',
        {text: 'Preț A (angajat)'},
        {'type': 'number', 'value': price_a}
    );

    const fieldPriceC = ESR.View.field(
        'sw-input-price-c',
        {text: 'Preț C (companie)'},
        {'type': 'number', 'value': price_c}
    );


    const popupContent = $(`<div class="esr-popup-fields grid grid-cols-2 gap-4"></div>`);

    popupContent.append(fieldTitle)
    //if is add new (not update)
    if (!id) popupContent.append(fieldCategory)
    popupContent.append(fieldPriceA)
    popupContent.append(fieldPriceC)
    popupContent.append(fFieldUnit)
    popupContent.append(fFieldVisibility)


    ESR.Popup.fire({
        title: popupTitle,
        html: popupContent,
        showCloseButton: true,
        confirmButtonText: confirmBtnText,
        cancelButtonText: ESR.lang.close,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
            const elInputTitle = $('#sw-input-title');
            const elInputCategory = $('#sw-input-category');
            const elInputPriceA = $('#sw-input-price-a');
            const elInputPriceC = $('#sw-input-price-c');
            const elInputUnit = $('#sw-input-unit');
            const elInputVisibility = $('#sw-input-visibility');

            const data = {
                post_id: id,
                title: elInputTitle.val().trim(),
                category_id: elInputCategory?.val(),
                price_a: elInputPriceA.val(),
                price_c: elInputPriceC.val(),
                unit: elInputUnit.val(),
                status: elInputVisibility.val(),
            }

            if (!data.title.length) {
                Swal.showValidationMessage('Completează denumirea');
                elInputTitle.focus();
                return;
            }

            if (!id && !data.category_id?.length) {
                Swal.showValidationMessage('Completează categoria');
                elInputCategory.focus();
                return;
            }

            if (!Helper.isValidPrice(data.price_a)) {
                Swal.showValidationMessage('Completează Prețul A');
                elInputPriceA.focus();
                return;
            }

            if (!Helper.isValidPrice(data.price_c)) {
                Swal.showValidationMessage('Completează Prețul C');
                elInputPriceC.focus();
                return;
            }


            if (!data.unit.length) {
                Swal.showValidationMessage('Completează unitate');
                elInputPriceA.focus();
                return;
            }

            return await ajaxRequest({action: "esr_update_service", data});
        },
        allowOutsideClick: () => !Swal.isLoading()
    });
}

export function popupCreateUpdateServiceCategory(rowData = {}, confirmBtnText) {

    const term_id = rowData?.term_id ?? 0;
    let popupTitle = 'Adaugă Categorie';
    let term_name = '';
    let visibility = 'true';

    if (term_id) {
        popupTitle = 'Editează Categoria'
        term_name = rowData?.term_name
        visibility = rowData.visibility
    }

    const fieldTitle = ESR.View.field(
        'sw-input-title',
        {text: 'Denumire Categorie'},
        {type: 'text', value: term_name}
    );

    const fFieldVisibility = ESR.View.field(
        'sw-input-visibility',
        {
            text: ESR.lang.visibility
        },
        {
            type: 'select',
            value: visibility,
            options: [
                {value: 'true', label: ESR.lang.visible},
                {value: 'false', label: ESR.lang.hidden}
            ]
        }
    );

    const popupContent = $(`<div class="esr-popup-fields grid grid-cols-1 gap-4"></div>`);

    popupContent.append(fieldTitle)
    popupContent.append(fFieldVisibility)

    ESR.Popup.fire({
        title: popupTitle,
        html: popupContent,
        showCloseButton: true,
        confirmButtonText: confirmBtnText,
        cancelButtonText: ESR.lang.close,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
            const elInputTitle = $('#sw-input-title');
            const elInputVisibility = $('#sw-input-visibility');

            const data = {
                term_id,
                term_name: elInputTitle.val().trim(),
                visibility: elInputVisibility.val(),
            }

            if (!data.term_name.length) {
                Swal.showValidationMessage('Completează denumirea');
                elInputTitle.focus();
                return;
            }

            return await ajaxRequest({action: "esr_update_service_category", data});
        },
        allowOutsideClick: () => !Swal.isLoading()
    });
}

export function popupResetPassword(user_id, name) {
    ESR.Popup.fire({
        title: 'Resetare Parola',
        html: `Doriți să resetați parola lui <b>${name}</b> ?`,
        showCloseButton: true,
        confirmButtonText: 'Resetează',
        cancelButtonText: ESR.lang.close,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
            return await ajaxRequest({action: "esr_reset_user_password", data: {user_id}});
        },
        allowOutsideClick: () => !Swal.isLoading()
    });
}

export function popupCreateUpdateTool(rowData = {}, confirmBtnText) {
    const id = rowData?.id ?? 0;
    let popupTitle = 'Adaugă Unealtă';
    let name = '';
    let serial_number = '';
    let inventory_code = '';
    let is_active = 1;

    if (id) {
        popupTitle = 'Editează Unealtă';
        name = rowData?.name ?? '';
        serial_number = rowData?.serial_number ?? '';
        inventory_code = rowData?.code ?? '';
        is_active = rowData?.is_active ?? 1;
    }


    const fieldName = ESR.View.field(
        'sw-input-name',
        {text: 'Denumire'},
        {type: 'text', value: name}
    );

    const fieldSerial = ESR.View.field(
        'sw-input-serial',
        {text: 'Serie'},
        {type: 'text', value: serial_number}
    );

    const fieldStatus = ESR.View.field(
        'sw-input-status',
        {
            text: ESR.lang.visibility
        },
        {
            type: 'select',
            value: is_active,
            options: [
                {value: 1, label: 'Activ'},
                {value: 0, label: 'Inactiv'}
            ]
        }
    );


    const popupContent = $(`<div class="esr-popup-fields grid grid-cols-1 gap-4"></div>`);
    popupContent.append(fieldName);
    popupContent.append(fieldSerial);


    // Show inventory code for edit mode (read-only)
    if (id) {
        const fieldInventory = ESR.View.field(
            'sw-input-inventory',
            {text: 'Cod Inventar'},
            {type: 'text', value: inventory_code, disabled: true}
        )

        popupContent.append(fieldInventory);
    }

    popupContent.append(fieldStatus);

    ESR.Popup.fire({
        title: popupTitle,
        html: popupContent,
        showCloseButton: true,
        confirmButtonText: confirmBtnText,
        cancelButtonText: ESR.lang.close,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
            const elInputName = $('#sw-input-name');
            const elInputSerial = $('#sw-input-serial');
            const elInputStatus = $('#sw-input-status');

            const data = {
                name: elInputName.val().trim(),
                serial_number: elInputSerial.val().trim(),
                is_active: elInputStatus.val()
            };

            if (id) {
                data.id = id;
            }

            if (!data.name.length) {
                Swal.showValidationMessage('Completează denumirea');
                elInputName.focus();
                return;
            }


            const action = id ? 'esr_update_tools' : 'esr_add_tools';
            return await ajaxRequest({action, data});
        },
        allowOutsideClick: () => !Swal.isLoading()
    });
}

